import React, { useEffect, useState } from "react";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { DELETE_LOGIN_METHOD, FETCH_ENUM_TYPES, GET_CHANNEL_LOGIN_METHODS } from "../../apiClient/apiEndpoints";
import { PlusIcon } from "../../assets/Icons";
import AddLoginMethods from "../../Modals/AddLoginMethods";
import { UiComponents } from "@simulanisindia/ui";

const { ConfirmBox } = UiComponents;

const LoginMethods = ({ id }) => {
  const [openModal, setOpenModal] = useState(false);
  const [methods, setMethods] = useState([]);
  const [allLoginMethods, setAllLoginMethods] = useState([]);
  const [modalMehodData, setModalMethodData] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [methodIdToDelete, setMethodIdToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getChannelLoginMethods = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${GET_CHANNEL_LOGIN_METHODS}/${id}`);
      setMethods(data.list);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllLoginMethods = async () => {
    try {
      let data = await apiClient(`${SSO_URL}${FETCH_ENUM_TYPES}/loginMethods`);
      setAllLoginMethods(Object.keys(data));
    } catch (error) {
      console.log(error);
    }
  };

  const openDeleteModal = (methodId) => {
    setMethodIdToDelete(methodId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setMethodIdToDelete(null);
    closeDeleteModal();
  };

  const handleEditClick = (value) => {
    setModalMethodData(value);
    setEditMode(true);
    setOpenModal(true);
  };

  const handleCreateClick = () => {
    setEditMode(false);
    setOpenModal(true);
  };

  const refreshPage = () => {
    getChannelLoginMethods();
    getAllLoginMethods();
  };

  const handleDeleteClick = async () => {
    try {
      const res = await apiClient.get(`${SSO_URL}${DELETE_LOGIN_METHOD}/${methodIdToDelete}`);
      getChannelLoginMethods();
      getAllLoginMethods();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getChannelLoginMethods();
    getAllLoginMethods();
  }, [id]);

  return (
    <>
      <div className="page-title childparents">
        <h5>Login Methods List</h5>
        <button className="DefaultRedBtn" onClick={handleCreateClick}>
          <PlusIcon />
          Add Login Methods
        </button>
      </div>
      <div className="table-responsive machinelist workflowtb mt-2">
        <table className="table align-middle table-nowrap mb-0">
          <thead>
            <tr>
              <th className="text-center">S.NO</th>
              <th>Type</th>
              <th className="text-left">Text</th>
              <th className="text-left">Data</th>
              <th className="text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {methods?.map((item, index) => {
              return (
                <tr>
                  <td className="text-center"> {index + 1} </td>
                  <td>{item?.type}</td>
                  <td className="text-left">{item?.text}</td>
                  <td className="text-left">{JSON.stringify(item?.data)}</td>
                  <td className="text-left">
                    <div className="d-flex gap-1">
                      <button className="btn btn-primary" onClick={() => handleEditClick(item)}>
                        Edit
                      </button>
                      <span className="btn btn-danger" onClick={() => openDeleteModal(item.id)}>
                        Delete
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <AddLoginMethods
        allLoginMethods={allLoginMethods}
        getChannelLoginMethods={getChannelLoginMethods}
        openModal={openModal}
        setOpenModal={setOpenModal}
        channelId={id}
        methodData={modalMehodData}
        editMode={editMode}
        refresh={refreshPage}
      />
      <ConfirmBox
        showModal={showDeleteModal}
        onHide={closeDeleteModal}
        onActionClick={handleDeleteClick}
        alertMessage="Are you sure"
        clickLoading={false}
        actionButtonItem="OK"
        alertTitle="DELETE LOGIN METHOD"
      />
    </>
  );
};

export default LoginMethods;
